import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';

/**
 * Default values for feature flags when LaunchDarkly is not available
 * or when flags haven't loaded yet
 */
const DEFAULT_FLAGS = {
  ldIsReady: false,
  canSeeRefreshTokens: false,
} as const;

/**
 * Type definition for all feature flags
 */
export type FeatureFlags = ReturnType<typeof useFlags> & {
  ldIsReady: boolean;
};

/**
 * Custom hook that provides access to LaunchDarkly feature flags with fallback values
 * @returns Feature flags object with typed values
 */
export const useFeatureFlags = (): FeatureFlags => {
  const flags = useFlags();
  const ldClient = useLDClient();

  // If LaunchDarkly client is not initialized or flags are not loaded yet,
  // return default values
  if (!ldClient || !flags) {
    return DEFAULT_FLAGS as FeatureFlags;
  }

  // Return flags with type safety, falling back to defaults for any undefined flags
  return {
    ...DEFAULT_FLAGS,
    ...flags,
    ldIsReady: true,
  };
};
